import { render } from "./CoverageResult.vue?vue&type=template&id=515fc58f"
import script from "./CoverageResult.vue?vue&type=script&lang=js"
export * from "./CoverageResult.vue?vue&type=script&lang=js"

import exportComponent from "/home/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__